import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { motion as Motion } from "motion/react";

export default function ImageUploadInput({ value, onChange }) {
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        // Devolver tanto el File object como la preview URL
        onChange({
          file: file,        // File object para enviar al servidor
          preview: reader.result  // Base64 para mostrar preview
        });
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="w-full">
      <label className="block text-sm font-medium text-gray-300 mb-2">
        Imagen del Evento
      </label>
      <div className="relative">
        {(value && (value.preview || value)) ? (
          <Motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="relative w-full h-[40dvh] rounded-sm overflow-hidden"
          >
            <img
              src={value.preview || value}
              alt="Preview"
              className="w-full h-full object-contain bg-aw-bluedark-95"
            />
            <button
              type="button"
              onClick={() => onChange("")}
              className="absolute top-2 right-2 w-8 h-8 rounded-full bg-red-500 hover:bg-red-600 text-white flex items-center justify-center transition duration-300"
            >
              <FontAwesomeIcon icon="fa-solid fa-times" />
            </button>
          </Motion.div>
        ) : (
          <label className="flex flex-col items-center justify-center w-full h-[40dvh] border-2 border-dashed border-gray-500 rounded-sm cursor-pointer hover:border-aw-green transition duration-300 bg-aw-bluedark-95">
            <FontAwesomeIcon
              icon="fa-solid fa-cloud-upload-alt"
              className="text-5xl text-gray-400 mb-3"
            />
            <p className="text-sm text-gray-400">
              Haz clic para subir una imagen
            </p>
            <p className="text-xs text-gray-500 mt-1">
              PNG, JPG, JPEG (MAX. 5MB)
            </p>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              className="hidden"
            />
          </label>
        )}
      </div>
    </div>
  );
}
